import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ModalService } from '@src/shared/modal/modal.service';
import { SimpleChanges } from '../../../../utils/types';
import {
  AdvancedTargetGroupCategory,
  AdvancedTargetGroupCategoryParams,
  AdvancedTargetGroupService,
} from '../../../../woo_services.module/AdvancedTargetGroupService';

@Component({
  selector: 'advanced-target-group-category-form',
  template: `
    <form #newCategoryForm="ngForm" (submit)="createCategory()">
      <div class="input__container">
        <label for="name">Namn</label>
        <input id="name" name="name" type="text" [(ngModel)]="category.name" required />
      </div>
      <button type="submit" class="button primary-1" [disabled]="newCategoryForm.invalid || nameTaken">Skapa</button>
      <button type="button" class="link primary" (click)="onClose.emit()">Avbryt</button>
    </form>
  `,
  standalone: false,
})
export class AdvancedTargetGroupCategoryForm implements OnChanges {
  @Input() categories: AdvancedTargetGroupCategory[] = [];
  @Output() onCreated = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();
  category: AdvancedTargetGroupCategoryParams = {
    name: null,
  };
  unavailableCategoryNames: string[] = [];

  constructor(private advancedTargetGroupService: AdvancedTargetGroupService, private modalService: ModalService) {}

  get nameTaken(): boolean {
    return this.unavailableCategoryNames.includes(this.category.name);
  }

  ngOnChanges(changes: SimpleChanges<AdvancedTargetGroupCategoryForm>): void {
    if (changes.categories && this.categories) {
      this.unavailableCategoryNames = this.categories.map((c) => c.name);
    }
  }

  async createCategory(): Promise<void> {
    const loaderModal = this.modalService.openLoader('Skapar kategori...');
    this.advancedTargetGroupService
      .createTargetGroupCategory(this.category)
      .then(() => {
        this.modalService.openSuccess('Ny kategori skapad!');
        this.onCreated.emit();
        this.onClose.emit();
      })
      .finally(() => {
        loaderModal.close();
      });
  }
}
